import { Howl } from 'howler';

type Callback = (sound: Sound) => void;

export class Sound {
    static setCategory() { }
    sound: Howl;

    constructor(asset: string, key: string, volume: number, error: (soundId: number, error: unknown) => void, onEnded: (key: string, soundId: number) => void) {
        this.sound = new Howl({
            src: [asset],
            volume: volume,
            onend: (id) => onEnded(key, id),
            onloaderror: error,
        });
    }

    play = async (callback?: Callback) => {
        await this.sound.play();
        if (callback) {
            callback(this);
        }
    };

    stop = async (callback?: Callback) => {
        await this.sound.stop();
        if (callback) {
            callback(this);
        }
    };
}